(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-card-gallery')) {
  customElements.define('gg-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('[data-ggcg-track]');
      this.slides = [...this.querySelectorAll('.ggcg__slide')];
      this.dots = [...this.querySelectorAll('[data-ggcg-index]')];
      if (!this.track || !this.dots.length) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.querySelector('.ggcg__dots').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-ggcg-index]');
        if (button) this.go(Number(button.dataset.ggcgIndex));
      }, options);
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const current = this.current || 0;
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
        event.preventDefault();
        this.go(index);
        this.dots[Math.max(0,Math.min(index,this.dots.length-1))].focus({preventScroll:true});
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, {...options,passive:true});
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({left:(this.current || 0)*this.track.clientWidth,behavior:'instant'});
        this.sync();
      });
      this.resize.observe(this.track);
      this.sync();
    }
    go(index) {
      index = Math.max(0,Math.min(index,this.slides.length-1));
      this.track.scrollTo({left:index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    sync() {
      if (!this.track.clientWidth) return;
      this.current = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.dots.forEach((dot,index) => dot.setAttribute('aria-pressed',String(index === this.current)));
      this.slides.forEach((slide,index) => { slide.tabIndex = index === this.current ? 0 : -1; });
    }
    disconnectedCallback() { this.abort?.abort();this.abort=null;this.resize?.disconnect();cancelAnimationFrame(this.frame); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-collection')) {
  class GGCollection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('is-enhanced');
      try { this.dataset.layout = sessionStorage.getItem('gg-collection-layout-v2') === 'standard' ? 'standard' : 'large'; } catch (_) {}
      this.viewport = matchMedia('(max-width:749px)');
      this.mobileStorageKey = `gg-collection-layout-mobile-v2-${this.dataset.categoryKind}`;
      try {
        const savedMobile = sessionStorage.getItem(this.mobileStorageKey);
        if (savedMobile === 'large' || savedMobile === 'standard') this.dataset.mobileLayout = savedMobile;
      } catch (_) {}
      this.viewportHandler = () => this.applyLayout();
      this.viewport.addEventListener('change', this.viewportHandler);
      this.applyLayout();
      const collectionRail = this.querySelector('.ggcn__links');
      const currentCollection = collectionRail?.querySelector('[aria-current="page"]');
      if (collectionRail && currentCollection) collectionRail.scrollLeft = currentCollection.getBoundingClientRect().left - collectionRail.getBoundingClientRect().left - 2;
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-gg-sort]')) return;
        const url = new URL(location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        this.loadPage(url, { focus: 'sort' });
      });
      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-gg-filter-form]');
        if (!form) return;
        event.preventDefault();
        const url = new URL(form.action, location.origin);
        const params = new URLSearchParams(new FormData(form));
        for (const [key, value] of Array.from(params.entries())) if (!value) params.delete(key);
        url.search = params.toString();
        this.closeDialog();
        this.loadPage(url, { focus: 'filter' });
      });
      this.popHandler = () => this.loadPage(new URL(location.href), { history: false });
      window.addEventListener('popstate', this.popHandler);
      this.observeMore();
    }
    disconnectedCallback() {
      this.requestController?.abort();
      this.moreController?.abort();
      this.moreObserver?.disconnect();
      window.removeEventListener('popstate', this.popHandler);
      this.viewport?.removeEventListener('change', this.viewportHandler);
      this.initialized = false;
    }
    onClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const open = target.closest('[data-gg-open]');
      if (open) {
        const dialog = this.querySelector('dialog');
        dialog.showModal();
        return;
      }
      if (target.closest('[data-gg-close]')) { this.closeDialog(); return; }
      if (target.matches('dialog')) {
        const rect = target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
        return;
      }
      const view = target.closest('[data-gg-view]');
      if (view) {
        const layout = view.dataset.ggView;
        if (this.viewport.matches) this.dataset.mobileLayout = layout;
        else this.dataset.layout = layout;
        try { sessionStorage.setItem(this.viewport.matches ? this.mobileStorageKey : 'gg-collection-layout-v2', layout); } catch (_) {}
        this.applyLayout();
        return;
      }
      const more = target.closest('a[data-gg-more]');
      if (more && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault(); this.loadMore(true); return; }
      const link = target.closest('a[data-gg-link]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const inDialog = Boolean(link.closest('dialog'));
      this.closeDialog();
      this.loadPage(new URL(link.href), { scroll: link.hasAttribute('data-gg-page'), focus: inDialog ? 'filter' : link.closest('.ggc__topics') ? 'topic' : 'count', topicLabel: link.querySelector('.ggc__topic-label')?.textContent });
    }
    closeDialog() { this.querySelector('dialog[open]')?.close(); }
    applyLayout() {
      const layout = this.viewport.matches ? this.dataset.mobileLayout : this.dataset.layout;
      this.querySelectorAll('[data-gg-view]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.ggView === layout)));
    }
    observeMore() {
      this.moreObserver?.disconnect();
      const sentinel = this.querySelector('[data-gg-sentinel]');
      if (!sentinel?.querySelector('[data-gg-more]') || !('IntersectionObserver' in window)) return;
      this.moreObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadMore();
      }, { rootMargin: '400px 0px' });
      this.moreObserver.observe(sentinel);
    }
    async loadMore(manual = false) {
      const link = this.querySelector('[data-gg-more]');
      if (!link || this.moreController || this.hasAttribute('aria-busy')) return;
      const controller = new AbortController();
      this.moreController = controller;
      const bottom = this.querySelector('[data-gg-bottom]');
      const status = this.querySelector('[data-gg-more-status]');
      status.textContent = link.dataset.loading;
      link.setAttribute('aria-disabled', 'true');
      bottom.setAttribute('aria-busy', 'true');
      const url = new URL(link.href, location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const timer = setTimeout(() => controller.abort('timeout'), 15000);
      try {
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const html = await response.text();
        if (controller.signal.aborted || !this.isConnected) return;
        const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('gg-collection');
        const nextBottom = incoming?.querySelector('[data-gg-bottom]');
        const incomingCards = incoming?.querySelectorAll('[data-gg-grid] > article');
        if (!nextBottom || !incomingCards?.length) throw new Error('Missing product grid');
        const grid = this.querySelector('[data-gg-grid]');
        const known = new Set([...grid.children].map(card => card.dataset.ggProductId));
        const fragment = document.createDocumentFragment();
        let firstNew;
        incomingCards.forEach(card => {
          if (known.has(card.dataset.ggProductId)) return;
          known.add(card.dataset.ggProductId);
          card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
          firstNew ||= card;
          fragment.append(card);
        });
        if (!firstNew) throw new Error('Repeated product page');
        grid.append(fragment);
        bottom.dataset.last = nextBottom.dataset.last;
        const showing = bottom.dataset.showing.replace('__first__', bottom.dataset.first).replace('__last__', bottom.dataset.last);
        bottom.querySelector('[data-gg-showing]').textContent = showing;
        this.querySelector('[data-gg-status]').textContent = showing;
        bottom.querySelector('[data-gg-sentinel]').replaceWith(nextBottom.querySelector('[data-gg-sentinel]'));
        if (manual) { const target = firstNew.querySelector('a'); target?.focus({preventScroll:true}); firstNew.scrollIntoView({block:'start',behavior:'instant'}); }
        this.observeMore();
      } catch(error) {
        if (!controller.signal.aborted || controller.signal.reason === 'timeout') {
          status.textContent = link.dataset.error;
          this.moreObserver?.disconnect();
          link.removeAttribute('aria-disabled');
        }
      } finally {
        clearTimeout(timer);
        if (this.moreController === controller) this.moreController = null;
        bottom.removeAttribute('aria-busy');
      }
    }
    async loadPage(url, options = {}) {
      this.moreController?.abort();
      this.moreController = null;
      this.moreObserver?.disconnect();
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-gg-status]').textContent = this.dataset.loading;
      url.searchParams.delete('section_id');
      url.hash = '';
      const requestUrl = new URL(url);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      const timeout = window.setTimeout(() => controller.abort('timeout'), 15000);
      try {
        const response = await fetch(requestUrl, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Section unavailable');
        const html = await response.text();
        if (controller.signal.aborted) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const content = documentFragment.querySelector('gg-collection [data-gg-content]');
        if (!content) throw new Error('Collection unavailable');
        const topicScroll = this.querySelector('.ggc__topics')?.scrollLeft || 0;
        const categoryScroll = Array.from(this.querySelectorAll('.ggcn__links, .ggcq__values')).map((rail) => rail.scrollLeft);
        const scrollPosition = window.scrollY;
        this.querySelector('[data-gg-content]').replaceWith(content);
        this.observeMore();
        this.applyLayout();
        const topics = this.querySelector('.ggc__topics');
        if (topics) topics.scrollLeft = topicScroll;
        this.querySelectorAll('.ggcn__links, .ggcq__values').forEach((rail, index) => { rail.scrollLeft = categoryScroll[index] || 0; });
        if (!options.scroll) window.scrollTo({ top: scrollPosition, behavior: 'instant' });
        if (options.history !== false && url.href !== location.href) history.pushState({}, '', url);
        const count = this.querySelector('[data-gg-count]');
        this.querySelector('[data-gg-status]').textContent = count.textContent;
        let focusTarget = count;
        if (options.focus === 'sort') focusTarget = this.querySelector('[data-gg-sort]');
        if (options.focus === 'filter') focusTarget = this.querySelector('[data-gg-open]');
        if (options.focus === 'topic') focusTarget = Array.from(this.querySelectorAll('.ggc__topic')).find((link) => link.querySelector('.ggc__topic-label')?.textContent === options.topicLabel) || count;
        if (options.focus || options.scroll) focusTarget.focus({ preventScroll: true });
        if (options.scroll) this.querySelector('.ggc__toolbar').scrollIntoView({ behavior: 'instant', block: 'start' });
      } catch (error) {
        if (!controller.signal.aborted || controller.signal.reason === 'timeout') location.assign(url);
      } finally {
        window.clearTimeout(timeout);
        if (this.requestController === controller) this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('gg-collection', GGCollection);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-mission-style"] && !Shopify.designMode) return;
  try {
    if (!window.ggMissionHomeReady) {
  window.ggMissionHomeReady = true;
  document.addEventListener('click', event => {
    const transform = event.target.closest('[data-ggm-transform]');
    if (transform) transform.setAttribute('aria-pressed', String(transform.getAttribute('aria-pressed') !== 'true'));
    const opener = event.target.closest('[data-ggm-film-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog || dialog.open) return;
      const frame = dialog.querySelector('iframe');
      if (frame && frame.dataset.src) frame.src = frame.dataset.src;
      dialog.showModal();
    }
    const closer = event.target.closest('[data-ggm-film-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.ggm-film')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('dialog.ggm-film')) return;
    event.target.querySelector('iframe')?.removeAttribute('src');
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('dialog.ggm-film[open]').forEach(dialog => dialog.close());
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-navigation-backup-20260928"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-navigation')) {
  customElements.define('gg-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-gg-panel]')];
      this.backdrop = this.querySelector('.gg-nav__backdrop');
      this.wrapper = this.closest('.header-wrapper');
      this.desktop = matchMedia('(min-width:1140px)');
      this.position = () => this.style.setProperty('--gg-nav-bottom', `${Math.max(0, this.wrapper.getBoundingClientRect().bottom)}px`);
      this.observer = new ResizeObserver(this.position);
      this.observer.observe(this.wrapper);
      this.position();
      this.panels.forEach(details => {
        const summary = details.querySelector('summary');
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) this.panels.filter(other => other !== details).forEach(other => other.open = false);
          this.sync();
        }, options);
        details.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType !== 'mouse' || !this.desktop.matches) return;
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => { details.open = true; this.position(); }, 170);
        }, options);
        summary.addEventListener('pointerdown', () => clearTimeout(this.openTimer), options);
        details.addEventListener('pointerleave', () => clearTimeout(this.openTimer), options);
        summary.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            details.open = true;
            details.querySelector('.gg-nav__panel a')?.focus();
          }
        }, options);
        details.querySelector('.gg-nav__close').addEventListener('click', () => { this.closeAll(); summary.focus(); }, options);
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = this.panels.find(details => details.open);
        if (current) { event.preventDefault(); event.stopPropagation(); this.closeAll(); current.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.closeAll(); });
      }, options);
      this.backdrop.addEventListener('click', () => this.closeAll(), options);
      this.backdrop.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
      this.desktop.addEventListener('change', () => this.closeAll(), options);
      window.addEventListener('scroll', this.position, { ...options, passive: true });
    }
    sync() {
      this.backdrop.hidden = !this.panels.some(details => details.open);
      this.position();
    }
    closeAll() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.panels.forEach(details => { details.open = false; details.querySelector('summary').setAttribute('aria-expanded', 'false'); });
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-navigation-backup-20260929"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-navigation')) {
  customElements.define('gg-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-gg-panel]')];
      this.backdrop = this.querySelector('.gg-nav__backdrop');
      this.wrapper = this.closest('.header-wrapper');
      this.desktop = matchMedia('(min-width:1140px)');
      this.position = () => this.style.setProperty('--gg-nav-bottom', `${Math.max(0, this.wrapper.getBoundingClientRect().bottom)}px`);
      this.observer = new ResizeObserver(this.position);
      this.observer.observe(this.wrapper);
      this.position();
      this.panels.forEach(details => {
        const summary = details.querySelector('summary');
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) this.panels.filter(other => other !== details).forEach(other => other.open = false);
          this.sync();
        }, options);
        details.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType !== 'mouse' || !this.desktop.matches) return;
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => { details.open = true; this.position(); }, 170);
        }, options);
        summary.addEventListener('pointerdown', () => clearTimeout(this.openTimer), options);
        details.addEventListener('pointerleave', () => clearTimeout(this.openTimer), options);
        summary.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            details.open = true;
            details.querySelector('.gg-nav__panel a')?.focus();
          }
        }, options);
        details.querySelector('.gg-nav__close').addEventListener('click', () => { this.closeAll(); summary.focus(); }, options);
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = this.panels.find(details => details.open);
        if (current) { event.preventDefault(); event.stopPropagation(); this.closeAll(); current.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.closeAll(); });
      }, options);
      this.backdrop.addEventListener('click', () => this.closeAll(), options);
      this.backdrop.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
      this.desktop.addEventListener('change', () => this.closeAll(), options);
      window.addEventListener('scroll', this.position, { ...options, passive: true });
    }
    sync() {
      this.backdrop.hidden = !this.panels.some(details => details.open);
      this.position();
    }
    closeAll() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.panels.forEach(details => { details.open = false; details.querySelector('summary').setAttribute('aria-expanded', 'false'); });
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-navigation-backup-20261001-vertodo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-navigation')) {
  customElements.define('gg-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-gg-panel]')];
      this.backdrop = this.querySelector('.gg-nav__backdrop');
      this.wrapper = this.closest('.header-wrapper');
      this.desktop = matchMedia('(min-width:1140px)');
      this.position = () => this.style.setProperty('--gg-nav-bottom', `${Math.max(0, this.wrapper.getBoundingClientRect().bottom)}px`);
      this.observer = new ResizeObserver(this.position);
      this.observer.observe(this.wrapper);
      this.position();
      this.panels.forEach(details => {
        const summary = details.querySelector('summary');
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) this.panels.filter(other => other !== details).forEach(other => other.open = false);
          this.sync();
        }, options);
        details.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType !== 'mouse' || !this.desktop.matches) return;
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => { details.open = true; this.position(); }, 170);
        }, options);
        summary.addEventListener('pointerdown', () => clearTimeout(this.openTimer), options);
        details.addEventListener('pointerleave', () => clearTimeout(this.openTimer), options);
        summary.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            details.open = true;
            details.querySelector('.gg-nav__panel a')?.focus();
          }
        }, options);
        details.querySelector('.gg-nav__close').addEventListener('click', () => { this.closeAll(); summary.focus(); }, options);
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = this.panels.find(details => details.open);
        if (current) { event.preventDefault(); event.stopPropagation(); this.closeAll(); current.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.closeAll(); });
      }, options);
      this.backdrop.addEventListener('click', () => this.closeAll(), options);
      this.backdrop.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
      this.desktop.addEventListener('change', () => this.closeAll(), options);
      window.addEventListener('scroll', this.position, { ...options, passive: true });
    }
    sync() {
      this.backdrop.hidden = !this.panels.some(details => details.open);
      this.position();
    }
    closeAll() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.panels.forEach(details => { details.open = false; details.querySelector('summary').setAttribute('aria-expanded', 'false'); });
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-navigation')) {
  customElements.define('gg-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-gg-panel]')];
      this.backdrop = this.querySelector('.gg-nav__backdrop');
      this.wrapper = this.closest('.header-wrapper');
      this.desktop = matchMedia('(min-width:1140px)');
      this.position = () => this.style.setProperty('--gg-nav-bottom', `${Math.max(0, this.wrapper.getBoundingClientRect().bottom)}px`);
      this.observer = new ResizeObserver(this.position);
      this.observer.observe(this.wrapper);
      this.position();
      this.panels.forEach(details => {
        const summary = details.querySelector('summary');
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) this.panels.filter(other => other !== details).forEach(other => other.open = false);
          this.sync();
        }, options);
        details.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType !== 'mouse' || !this.desktop.matches) return;
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => { details.open = true; this.position(); }, 170);
        }, options);
        summary.addEventListener('pointerdown', () => clearTimeout(this.openTimer), options);
        details.addEventListener('pointerleave', () => clearTimeout(this.openTimer), options);
        summary.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            details.open = true;
            details.querySelector('.gg-nav__panel a')?.focus();
          }
        }, options);
        details.querySelector('.gg-nav__close').addEventListener('click', () => { this.closeAll(); summary.focus(); }, options);
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = this.panels.find(details => details.open);
        if (current) { event.preventDefault(); event.stopPropagation(); this.closeAll(); current.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.closeAll(); });
      }, options);
      this.backdrop.addEventListener('click', () => this.closeAll(), options);
      this.backdrop.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => this.closeAll(), 240);
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.closeAll(); }, options);
      this.desktop.addEventListener('change', () => this.closeAll(), options);
      window.addEventListener('scroll', this.position, { ...options, passive: true });
    }
    sync() {
      this.backdrop.hidden = !this.panels.some(details => details.open);
      this.position();
    }
    closeAll() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.panels.forEach(details => { details.open = false; details.querySelector('summary').setAttribute('aria-expanded', 'false'); });
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-product-gallery')) {
  customElements.define('gg-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.classList.add('is-enhanced');
      this.addEventListener('click', (event) => {
        const target = event.target.closest('a,button,dialog');
        if (!target) return;
        if (target.hasAttribute('data-gg-thumbnail')) { event.preventDefault(); this.showMedia(target.dataset.ggThumbnail); }
        if (target.hasAttribute('data-gg-previous')) this.move(-1);
        if (target.hasAttribute('data-gg-next')) this.move(1);
        if (target.hasAttribute('data-gg-zoom')) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openZoom(target);
        }
        if (target.hasAttribute('data-gg-zoom-previous')) this.moveZoom(-1);
        if (target.hasAttribute('data-gg-zoom-next')) this.moveZoom(1);
        if (target.hasAttribute('data-gg-close-zoom')) this.querySelector('dialog').close();
        if (target.matches('dialog')) { const r = target.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) target.close(); }
      }, options);
      this.querySelector('.ggpg__stage').addEventListener('keydown', (event) => {
        if (matchMedia('(min-width:990px)').matches || event.target.closest('video,iframe,model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1); }
      }, options);
      const dialog = this.querySelector('dialog');
      dialog.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.moveZoom(event.key === 'ArrowLeft' ? -1 : 1); } }, options);
      dialog.addEventListener('close', () => this.zoomTrigger?.focus({ preventScroll: true }), options);
      this.querySelector('.ggpg__zoom-content').addEventListener('scroll', () => this.updateZoomCount(), { ...options, passive: true });
      let touchX = null, touchY = null;
      this.querySelector('.ggpg__stage').addEventListener('touchstart', (event) => { touchX = event.touches.length === 1 ? event.touches[0].clientX : null; touchY = event.touches[0]?.clientY; }, { ...options, passive: true });
      this.querySelector('.ggpg__stage').addEventListener('touchend', (event) => { if (touchX === null || matchMedia('(min-width:990px)').matches || event.target.closest('video,iframe,model-viewer')) return; const delta = event.changedTouches[0].clientX - touchX; if (Math.abs(delta) > 50 && Math.abs(delta) > Math.abs(event.changedTouches[0].clientY - touchY)) this.move(delta < 0 ? 1 : -1); touchX = null; }, { ...options, passive: true });
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    openZoom(target) {
      this.zoomTrigger = target;
      const track = this.querySelector('.ggpg__zoom-content');
      const links = Array.from(this.querySelectorAll('[data-gg-zoom]'));
      this.zoomIndex = links.indexOf(target);
      if (!track.children.length) track.replaceChildren(...links.map(link => {
        const img = document.createElement('img'); img.src = link.href; img.alt = link.querySelector('img').alt; img.loading = 'lazy'; img.decoding = 'async'; img.draggable = false; return img;
      }));
      this.querySelector('dialog').showModal();
      track.scrollTo({ left: this.zoomIndex * track.clientWidth, behavior: 'instant' });
      this.updateZoomCount();
    }
    updateZoomCount() {
      const track = this.querySelector('.ggpg__zoom-content');
      this.zoomIndex = Math.round(track.scrollLeft / (track.clientWidth || 1));
      this.querySelector('[data-gg-zoom-count]').textContent = `${this.zoomIndex + 1} / ${track.children.length}`;
    }
    moveZoom(direction) {
      const track = this.querySelector('.ggpg__zoom-content');
      const next = (this.zoomIndex + direction + track.children.length) % track.children.length;
      track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    move(direction) {
      const slides = Array.from(this.querySelectorAll('[data-gg-media]'));
      const current = slides.findIndex((slide) => slide.dataset.ggMedia === this.dataset.selectedMedia);
      const next = slides[(current + direction + slides.length) % slides.length];
      if (next) this.showMedia(next.dataset.ggMedia);
    }
    showMedia(id) {
      const slide = Array.from(this.querySelectorAll('[data-gg-media]')).find((item) => item.dataset.ggMedia === String(id));
      if (!slide) return;
      this.querySelectorAll('[data-gg-media]').forEach((item) => { item.classList.toggle('is-current', item === slide); if (item !== slide) item.querySelectorAll('video').forEach((video) => video.pause()); });
      this.querySelectorAll('[data-gg-thumbnail]').forEach((thumb) => thumb.setAttribute('aria-current', String(thumb.dataset.ggThumbnail === String(id))));
      const count = this.querySelector('[data-gg-media-count]'); if (count) count.textContent = slide.dataset.mediaIndex;
      const thumb = Array.from(this.querySelectorAll('[data-gg-thumbnail]')).find((item) => item.dataset.ggThumbnail === String(id));
      if (matchMedia('(min-width:990px)').matches) slide.scrollIntoView({ block: 'center', behavior: 'instant' });
      else if (thumb) this.querySelector('.ggpg__thumbs').scrollTo({ left: Math.max(0, thumb.offsetLeft - this.querySelector('.ggpg__thumbs').offsetLeft - 100), behavior: 'instant' });
      this.dataset.selectedMedia = String(id);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-product-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-product-shipping')) {
  customElements.define('gg-product-shipping', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const details = this.closest('details');
      details?.addEventListener('toggle', () => { if (details.open && !this.regions) this.loadRegions(); });
      this.querySelector('[name="province"]').addEventListener('change', () => {
        const province = this.regions?.find((item) => item.provinceCode === this.querySelector('[name="province"]').value);
        const cities = this.querySelector('[name="city"]'); cities.replaceChildren(new Option(this.dataset.cityPlaceholder, ''));
        province?.provinceCities?.forEach((city) => cities.add(new Option(city.cityName, city.cityName)));
        cities.disabled = !province; this.querySelector('button').disabled = !province; this.querySelector('.ggpship__status').replaceChildren();
      });
      this.querySelector('form').addEventListener('submit', (event) => { event.preventDefault(); this.quote(); });
    }
    async loadRegions() {
      if (this.loading) return; this.loading = true;
      try {
        const response = await fetch(this.dataset.regionsUrl, { signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Unavailable');
        const regions = await response.json();
        if (!Array.isArray(regions) || !regions.length) throw new Error('No regions');
        this.regions = regions;
        const select = this.querySelector('[name="province"]');
        regions.forEach((province) => select.add(new Option(province.provinceName, province.provinceCode)));
        select.disabled = false;
      } catch (error) { this.querySelector('.ggpship__status').textContent = this.dataset.error; }
      finally { this.loading = false; }
    }
    async quote() {
      const status = this.querySelector('.ggpship__status'); const button = this.querySelector('button');
      button.disabled = true; status.textContent = this.dataset.loading;
      try {
        const cartResponse = await fetch(this.dataset.cartUrl + '.js', { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cart = await cartResponse.json();
        if (!cart.item_count) { status.textContent = this.dataset.empty; return; }
        const params = new URLSearchParams({ 'shipping_address[country]': 'CL', 'shipping_address[province]': this.querySelector('[name="province"]').value, 'shipping_address[city]': this.querySelector('[name="city"]').value, 'shipping_address[zip]': 'WW' });
        const response = await fetch(this.dataset.cartUrl + '/shipping_rates.json?' + params, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('Rates unavailable');
        const result = await response.json();
        if (!Array.isArray(result.shipping_rates)) throw new Error('Invalid rates');
        status.replaceChildren();
        if (!result.shipping_rates.length) { status.textContent = this.dataset.noRates; return; }
        const money = new Intl.NumberFormat(document.documentElement.lang || 'es-CL', { style: 'currency', currency: cart.currency || 'CLP', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
        result.shipping_rates.forEach((rate) => { const row = document.createElement('div'); const label = document.createElement('span'); label.textContent = rate.name; const price = document.createElement('strong'); price.textContent = money.format(Number(rate.price)); row.append(label, price); status.append(row); });
        const note = document.createElement('small'); note.textContent = this.dataset.rateNote; status.append(note);
      } catch (error) { status.textContent = this.dataset.error; }
      finally { button.disabled = false; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-search')) customElements.define('gg-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[type=search]');
      this.results = this.querySelector('[data-gg-search-results]');
      this.discover = this.querySelector('[data-gg-search-discover]');
      this.status = this.querySelector('[data-gg-search-status]');
      this.clearButton = this.querySelector('[data-gg-search-clear]');
      this.trigger = this.querySelector('[data-gg-search-open]');
      this.cache = new Map();
      this.trigger.addEventListener('click', event => {
        if (!this.dialog.showModal) return;
        event.preventDefault();
        document.querySelectorAll('.gg-nav__details[open]').forEach(details => details.open = false);
        const menu = document.querySelector('#Details-menu-drawer-container[open] > summary');
        if (menu) menu.click();
        this.dialog.showModal();
        this.input.focus();
        if (this.input.value.trim().length >= 2) this.change(true);
      });
      this.querySelector('[data-gg-search-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        clearTimeout(this.timer);
        this.request?.abort();
        this.status.textContent = '';
        this.results.removeAttribute('aria-busy');
        this.trigger.focus();
      });
      this.input.addEventListener('input', () => this.change());
      this.input.addEventListener('keydown', event => this.keydown(event));
      this.clearButton.addEventListener('click', () => { this.input.value = ''; this.change(); this.input.focus(); });
      this.querySelectorAll('[data-gg-search-term]').forEach(button => button.addEventListener('click', () => {
        this.input.value = button.dataset.ggSearchTerm;
        this.change(true);
        this.input.focus();
      }));
      this.querySelector('form').addEventListener('submit', event => { if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); } });
    }
    change(immediate = false) {
      clearTimeout(this.timer);
      this.request?.abort();
      const term = this.input.value.trim();
      this.clearButton.hidden = !term;
      this.input.removeAttribute('aria-activedescendant');
      this.input.setAttribute('aria-expanded', 'false');
      this.results.hidden = true;
      this.results.removeAttribute('aria-busy');
      this.discover.hidden = term.length >= 2;
      this.status.textContent = '';
      if (term.length < 2) return;
      this.status.textContent = this.dataset.loading;
      this.timer = setTimeout(() => this.search(term), immediate ? 0 : 220);
    }
    async search(term) {
      this.request = new AbortController();
      const currentRequest = this.request;
      this.results.setAttribute('aria-busy', 'true');
      try {
        let markup = this.cache.get(term);
        if (!markup) {
          const params = new URLSearchParams({ q: term, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last', section_id: 'gg-predictive-search' });
          const response = await fetch(this.dataset.url + '?' + params.toString(), { signal: currentRequest.signal });
          if (!response.ok) throw new Error('search');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-gg-results]');
          if (!content) throw new Error('search');
          markup = content.outerHTML;
          if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(term, markup);
        }
        if (term !== this.input.value.trim() || !this.dialog.open || currentRequest.signal.aborted) return;
        this.results.innerHTML = markup;
        this.results.hidden = false;
        this.status.textContent = this.results.querySelector('[data-gg-results]').dataset.announcement;
        this.input.setAttribute('aria-expanded', String(this.results.querySelectorAll('[role=option]').length > 0));
      } catch (error) {
        if (error.name !== 'AbortError' && term === this.input.value.trim() && this.dialog.open) {
          this.status.textContent = this.dataset.error;
          this.discover.hidden = false;
        }
      } finally {
        if (this.request === currentRequest) this.results.removeAttribute('aria-busy');
      }
    }
    keydown(event) {
      const options = [...this.results.querySelectorAll('[role=option]')];
      if (this.results.hidden || !options.length) return;
      const selected = options.findIndex(option => option.getAttribute('aria-selected') === 'true');
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const next = selected < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (selected + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach((option, index) => option.setAttribute('aria-selected', String(index === next)));
        this.input.setAttribute('aria-activedescendant', options[next].id);
        options[next].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && selected >= 0) {
        event.preventDefault();
        options[selected].querySelector('a').click();
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.request?.abort(); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-shipping-benefit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-shipping-benefit')) customElements.define('gg-shipping-benefit', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'cart' || this.ready) return;
      try { this.config = JSON.parse(this.querySelector('[data-gg-ship-config]').textContent); } catch { return; }
      this.ready = true; this.revision = 0; this.abort = new AbortController();
      const sync = event => { if (event.detail?.cart) { this.revision++; this.paint(event.detail.cart); } else this.refresh(); };
      ['cart:updated', 'cart:refresh', 'gg:cart-content-changed'].forEach(name => document.addEventListener(name, sync, { signal:this.abort.signal }));
      this.refresh();
    }
    refresh() {
      const revision = ++this.revision;
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        try {
          const response = await fetch(this.dataset.root + 'cart.js', { credentials:'same-origin', headers:{ Accept:'application/json' }, signal:this.abort.signal });
          if (!response.ok) return;
          const cart = await response.json();
          if (this.isConnected && revision === this.revision) this.paint(cart);
        } catch {}
      }, 180);
    }
    paint(cart) {
      if (cart.currency !== 'CLP' || !Number.isFinite(cart.total_price)) return;
      const total = cart.total_price;
      const threshold = this.config.threshold;
      const reached = total > threshold;
      const remaining = Math.max(0, threshold + 100 - total);
      const money = new Intl.NumberFormat('es-CL', { style:'currency', currency:'CLP', maximumFractionDigits:0 }).format(Math.ceil(remaining / 100));
      this.querySelector('[data-gg-ship-message]').textContent = reached ? this.config.reached : this.config.remaining.replace('{amount}', money);
      const progress = this.querySelector('[data-gg-ship-progress]');
      progress.hidden = false; progress.firstElementChild.style.width = `${Math.min(100, total / (threshold + 100) * 100)}%`;
      this.dataset.reached = String(reached);
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.timer); this.ready = false; }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-special-film"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gg-special-film'))customElements.define('gg-special-film',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;const video=this.querySelector('video'),button=this.querySelector('[data-native-play]');if(!video||!button)return;button.hidden=false;button.addEventListener('click',()=>{video.play().catch(()=>{button.hidden=false;});});video.addEventListener('play',()=>{document.querySelectorAll('gg-brand-film').forEach(film=>film.close?.(false));document.querySelectorAll('.ggb video').forEach(other=>{if(other!==video)other.pause();});});video.addEventListener('playing',()=>{button.hidden=true;});video.addEventListener('pause',()=>{button.hidden=false;});video.addEventListener('ended',()=>{button.hidden=false;});}
  disconnectedCallback(){this.querySelector('video')?.pause();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-story-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-story-video')) {
  customElements.define('gg-story-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.abort = new AbortController(); const options = { signal: this.abort.signal };
      const video = this.querySelector('video'), button = this.querySelector('[data-gg-play]'), sound = this.querySelector('[data-gg-sound]'), toggle = this.querySelector('[data-gg-toggle]');
      if (!video || !button) return;
      const silent = this.hasAttribute('data-silent');
      video.setAttribute('aria-label', this.dataset.videoTitle || '');
      this.video = video; video.muted = true; video.playsInline = true; video.controls = !silent;
      button.hidden = false;
      const autoAllowed = !matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData;
      let manuallyPaused = false;
      const failure = () => { button.hidden = false; video.controls = !silent; };
      const sync = () => {
        this.classList.toggle('is-paused', video.paused);
        if (toggle) { toggle.hidden = false; toggle.setAttribute('aria-label', video.paused ? toggle.dataset.play : toggle.dataset.pause); }
      };
      const play = (manual = false) => {
        if (!manual && (!autoAllowed || !this.visible || document.hidden || manuallyPaused)) return;
        if (manual) manuallyPaused = false;
        this.querySelector('.ggsv__error').hidden = true;
        video.play().catch(failure);
      };
      button.addEventListener('click', () => play(true), options);
      toggle?.addEventListener('click', () => { if (video.paused) play(true); else { manuallyPaused = true; video.pause(); } }, options);
      sound?.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) document.querySelectorAll('gg-story-video video').forEach(other => { if (other !== video) other.muted = true; });
        if (video.paused) play(true);
      }, options);
      video.addEventListener('volumechange', () => {
        if (silent) { if (!video.muted) video.muted = true; return; }
        if (sound) { sound.setAttribute('aria-pressed', String(!video.muted)); sound.textContent = video.muted ? sound.dataset.soundOn : sound.dataset.soundOff; }
      }, options);
      video.addEventListener('play', () => { this.classList.add('is-started'); button.hidden = true; if (sound) sound.hidden = false; sync(); }, options);
      video.addEventListener('pause', sync, options);
      video.addEventListener('error', () => { failure(); this.querySelector('.ggsv__error').hidden = false; }, options);
      this.addEventListener('pointerenter', () => play(), options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .6;
        if (this.visible) play(); else video.pause();
      }, { threshold: [0, .6] });
      this.observer.observe(this);
      sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); this.video?.pause(); this.ready = false; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-swipe-track"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gg-swipe-track'))customElements.define('gg-swipe-track',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};
  this.addEventListener('dragstart',event=>event.preventDefault(),options);
  this.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('button,input,video'))return;this.drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft};},options);
  this.addEventListener('pointermove',event=>{const drag=this.drag;if(!drag||drag.id!==event.pointerId)return;const dx=event.clientX-drag.x,dy=event.clientY-drag.y;if(!drag.active&&Math.abs(dx)>6&&Math.abs(dx)>Math.abs(dy)){drag.active=true;this.classList.add('is-dragging');this.setPointerCapture(event.pointerId);}if(drag.active){event.preventDefault();this.scrollLeft=drag.left-dx;}},options);
  const finish=()=>{const drag=this.drag;if(!drag)return;this.drag=null;if(this.hasPointerCapture(drag.id))this.releasePointerCapture(drag.id);this.classList.remove('is-dragging');if(drag.active){this.suppressUntil=Date.now()+350;const first=this.firstElementChild;const max=Math.max(0,this.scrollWidth-this.clientWidth);const positions=[...this.children].map(child=>Math.min(max,child.offsetLeft-(first?.offsetLeft||0)));positions.push(max);const nearest=positions.reduce((best,left)=>Math.abs(left-this.scrollLeft)<Math.abs(best-this.scrollLeft)?left:best,0);this.scrollTo({left:nearest,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}};
  this.addEventListener('pointerup',finish,options);this.addEventListener('pointercancel',finish,options);this.addEventListener('lostpointercapture',finish,options);
  this.addEventListener('click',event=>{if(Date.now()<(this.suppressUntil||0)){event.preventDefault();event.stopImmediatePropagation();}},{...options,capture:true});
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.drag=null;this.classList.remove('is-dragging');}
});
  } catch(e) { console.error(e); }
})();

})();
